/**
 * Ramène une saisie à un ENTIER borné, ou à la chaîne vide.
 *
 * Règle unique de `IntegerField`, isolée ici pour deux raisons : un `.jsx` qui
 * exporte autre chose qu'un composant casse le Fast Refresh (règle eslint
 * react-refresh/only-export-components, en erreur sur ce projet), et une
 * fonction pure se teste sans monter de DOM.
 *
 * @param {*} raw Valeur brute lue sur l'input.
 * @param {number|null} min Borne basse INCLUSE, ou null pour ne pas borner.
 * @param {number|null} max Borne haute INCLUSE, ou null pour ne pas borner.
 * @returns {number|string} Un entier dans [min, max], ou '' si pas de valeur.
 */
export function clampToInteger(raw, min = null, max = null) {
    if (raw === '' || raw === null || raw === undefined) return '';
    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) return '';

    let value = Math.round(parsed);
    if (min !== null && value < min) value = min;
    if (max !== null && value > max) value = max;
    // Math.round(-0.4) rend -0 : anodin une fois sérialisé, mais autant ne
    // jamais laisser sortir une valeur qui n'est pas strictement égale à 0.
    return Object.is(value, -0) ? 0 : value;
}

/**
 * Lit une borne de props : un nombre exploitable, sinon null (= pas de borne).
 *
 * @param {*} value La valeur de prop, déjà résolue par le moteur de templates.
 * @returns {number|null} La borne, ou null.
 */
export function toBound(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
}
